import React from 'react';
import { X, AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';
import { useNotification, NotificationType } from '../contexts/NotificationContext';

const icons: Record<NotificationType, React.ElementType> = {
  info: Info,
  success: CheckCircle,
  warning: AlertTriangle,
  error: AlertCircle,
};

const colors: Record<NotificationType, { bg: string; text: string; icon: string }> = {
  info: { bg: 'bg-blue-50', text: 'text-blue-800', icon: 'text-blue-400' },
  success: { bg: 'bg-green-50', text: 'text-green-800', icon: 'text-green-400' },
  warning: { bg: 'bg-yellow-50', text: 'text-yellow-800', icon: 'text-yellow-400' },
  error: { bg: 'bg-red-50', text: 'text-red-800', icon: 'text-red-400' },
};

export default function NotificationToast() {
  const { notifications, removeNotification } = useNotification();

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {notifications.map((notification) => {
        const Icon = icons[notification.type];
        const color = colors[notification.type];

        return (
          <div
            key={notification.id}
            className={`${color.bg} p-4 rounded-lg shadow-lg max-w-sm flex items-start animate-slide-in`}
          >
            <Icon className={`${color.icon} w-5 h-5 mt-0.5`} />
            <div className={`${color.text} ml-3 flex-1`}>
              <p className="text-sm font-medium">{notification.message}</p>
            </div>
            <button
              onClick={() => removeNotification(notification.id)}
              className={`${color.text} ml-4 inline-flex flex-shrink-0`}
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}